import { TextHTML } from '@/components/typography'

import { TextBlockProps } from './types'

export const TextBlock = ({ className, text, iconNode, underIconText }: TextBlockProps) => {
  className = 'text-block' + (className ? ` ${className}` : '')

  return (
    <div className={className}>
      <div className="text-with-icon-wrapper">
        {iconNode && (
          <div className="image-container">
            {iconNode && typeof iconNode === 'object' && 'src' in iconNode ? (
              <img src={iconNode.src} alt="" loading="lazy" />
            ) : (
              iconNode
            )}
          </div>
        )}
        {text && <TextHTML className="text" title={typeof text === 'function' ? text() : text} />}
      </div>
      {underIconText && <TextHTML className="text undericon-text" title={underIconText} />}
    </div>
  )
}
